//# sourceMappingURL=interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-ui-router/lib-esm/interface.js
// module id = 291
// module chunks = 0